import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../services/common.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-icici-elevate-success",
  templateUrl: "./icici-elevate-success.component.html",
  styleUrls: ["./icici-elevate-success.component.css"],
})
export class IciciElevateSuccessComponent implements OnInit {
  transactionData: any;
  plandetail: any = {};
  policyNo;
  proposal: any = {
    address: {},
    nominee: {},
  };
  policyStatus;
  loading: boolean;
  downloadCertificate: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.transactionData = params;
      this.startLoading();
      this.checkPolicystatus(this.transactionData).subscribe({
        next: (response) => {
          if (response.Success === true) {
            this.stopLoading();
            this.plandetail.TxRefNo = response.TransactionId;
            this.policyNo = response.PolicyNumber;
            this.policyStatus = response.ProposalStatus;
          } else {
            this.toastr.error("Policy issuance failed or is pending.");
            this.startLoading();
          }
        },
        error: (error) => {
          console.error("Policy status check failed", error);
          this.toastr.error("Error checking policy status");
          this.stopLoading();
        },
      });
    });
    this.proposal = JSON.parse(localStorage.getItem("proposal_Proposer"));
  }

  checkPolicystatus(transactionData) {
    const data = JSON.parse(
      localStorage.getItem("icici_elevate_quote_payload")
    );
    const url = "/icici/policyStatus";
    const body = {
      payload: {
        RequestId: data.RequestId,
        TransactionId: this.transactionData.t,
      },
    };
    return this.commonService.post(url, body);
  }

  downloadPDF() {
    this.downloadCertificate = true;
    this.startLoading();
    const url = `/icici/downloadCOI/${this.transactionData.t}`;

    this.commonService.getpdf(url, { responseType: "blob" }).subscribe({
      next: (response: Blob) => {
        const downloadUrl = window.URL.createObjectURL(response);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = `COI_${this.transactionData.t}.pdf`;
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        this.downloadCertificate = false;
        this.stopLoading();
      },
      error: (err) => {
        this.stopLoading();
        this.downloadCertificate = false;
        console.error("Error downloading PDF:", err);
      },
    });
  }

  startLoading() {
    this.loading = true;
  }

  stopLoading() {
    this.loading = false;
  }
}
